import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppSelector } from '../../logic/store/Store';

/*
	Watches PostLoginProgress and navigates to the resolved landingPage
	once the post-login flow finishes.
*/
export const PostLoginRedirector = () =>
{
	const history = useHistory();
	const status = useAppSelector(state => state.ui.PostLoginProgress.status);
	const landingPage = useAppSelector(state => state.ui.PostLoginProgress.landingPage);
	const isAuthenticated = useAppSelector(state => state.auth.isAuthenticated);

	// Track the last landingPage we already acted on so we don't fight with
	// in-app navigation after the initial redirect.
	const lastHandledRef = useRef<string | undefined>(undefined);

	useEffect(() =>
	{
		if (!isAuthenticated) return;
		if (status !== 'done') return;
		if (!landingPage) return;
		if (lastHandledRef.current === landingPage) return;

		const currentPath = window.location.pathname;
		// landingPage may include a query string; compare against just the pathname
		// portion so we don't redirect when we're already on the right page.
		const targetPath = landingPage.split('?')[0];
		if (currentPath === targetPath)
		{
			lastHandledRef.current = landingPage;
			return;
		}

		lastHandledRef.current = landingPage;
		history.push(landingPage);
	}, [isAuthenticated, status, landingPage, history]);

	return null;
};
